import type {
  ApiContract,
  Response,
} from 'lib/api-mocking/interfaces/ApiContract';
import { defaultErrorResponse } from 'mockApi/responses/defaultErrorResponse';
import type { Error } from 'models/Error';
import { OrganizationResponseModelPaginatedList } from 'types/api';
import { OrganizationListGenerator } from '../generators/OrganizationsGenerator';

const contract: ApiContract = {
  url: '/Organizations',
  method: 'GET',
  success: (): Response<OrganizationResponseModelPaginatedList> => {
    return {
      status: 200,
      body: OrganizationListGenerator.generate({ items: 10 }),
    };
  },
  error: (): Response<Error> => ({
    status: 500,
    body: defaultErrorResponse,
  }),
  scope: {
    test: true,
    runtime: false,
  },
};

export default contract;
